import breakpoint from './breakpoint';

export default function lineClamp(node: HTMLElement): void {
    const {
        dataset: { jsLineclamp: breakpointAndUp }
    } = node;
    const {
        documentElement: { clientWidth }
    } = document;

    if (clientWidth >= breakpoint.sizes[breakpointAndUp]) {
        // resetting
        requestAnimationFrame(() => {
            node.style.maxHeight = '';
            node.style.webkitLineClamp = '';
        });

        const compStyles = window.getComputedStyle(node);
        const lineHeight = parseInt(compStyles.getPropertyValue('line-height'));
        const { clientHeight } = node;
        let clampLines = Math.floor(clientHeight / lineHeight);
        if (clampLines < 1) {
            clampLines = 1;
        }
        const newHeight = clampLines * lineHeight;

        // applying line clamp
        requestAnimationFrame(() => {
            node.style.maxHeight = `${newHeight + 3}px`;
            node.style.webkitLineClamp = `${clampLines}`;
        });
    }
}
